/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxUserSettingAmountSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_USER_SETTING_AMOUNT')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class MaxUserSettingAmountSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxUserSettingAmountSettingParser.decode(input).map(res => new MaxUserSettingAmountSetting(res));
    }
    static unsafeDecode(input) {
        return MaxUserSettingAmountSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxUserSettingAmountSettingParser.encode(data);
    }
    static schema() {
        return MaxUserSettingAmountSettingParser.schema();
    }
}
